import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = 'https://8d6827da321f2f73d112dc9fa49d3bc3@o173594.ingest.sentry.io/4506189559693312';
if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_SENTRY_ENV || 'development',
	});
}

hydrate();
